export default "__VITE_ASSET__rtDB6$Gi__"